// extracted by mini-css-extract-plugin
export default {"section__title":"style_section__title__1pYcl"};